import React, { useState } from "react";
import styled from "styled-components";
import { FiFileText, FiShield, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const ConsentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: -webkit-fill-available;
  padding: 20px;
  background-color: #ffffff;
`;

const Title = styled.h2`
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
`;

const TermsList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: auto;
`;

const TermItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
`;

const IconWrapper = styled.div`
  margin-right: 12px;
  font-size: 20px;
  color: #555;
`;

const TermContent = styled.div`
  font-size: 16px;
  color: #555;

  strong {
    color: #000;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;

  input {
    margin-right: 8px;
    margin-top: 2px;
  }
`;

const ProceedButton = styled.button`
  padding: 12px;
  font-size: 16px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ConsentScreen = () => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate("/onBoarding");
  };
  return (
    <ConsentContainer>
      <Title>Please Review & Accept Our Terms</Title>

      <TermsList>
        <TermItem>
          <IconWrapper>
            <FiFileText />
          </IconWrapper>
          <TermContent>
            <strong>Terms of Service</strong> – Understand your rights and
            responsibilities.
          </TermContent>
        </TermItem>

        <TermItem>
          <IconWrapper>
            <FiShield />
          </IconWrapper>
          <TermContent>
            <strong>Privacy Policy</strong> – Learn how we collect, use, and
            protect your data.
          </TermContent>
        </TermItem>

        <TermItem>
          <IconWrapper>
            <FiUser />
          </IconWrapper>
          <TermContent>
            <strong>User Rights</strong> – Manage your preferences and control
            your information.
          </TermContent>
        </TermItem>
      </TermsList>

      <CheckboxWrapper>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
        <strong>
          “Accept & Continue", you agree to our Terms and Privacy Policy.
        </strong>
      </CheckboxWrapper>

      <ProceedButton disabled={!isChecked} onClick={handleProceed}>
        Proceed
      </ProceedButton>
    </ConsentContainer>
  );
};

export default ConsentScreen;
